import { v4 as uuidv4 } from 'uuid'
import { ENTITY_TYPE } from '../../constants'
import { uploadFileToGoogleDrive } from './GoogleDriveUploader'

// Profile photos live on the merchant's Google Drive, exactly like Android/iOS
// (FileSystemWithBackUp + GoogleDriveUploader). The file reference mirrors the KMP
// `FileReference` helpers so the three apps tag the same Drive file the same way:
//   business/{businessId}/profile
//   business/{businessId}/account/{CUSTOMER|SUPPLIER}/{accountId}/profile
export const businessProfileImageReference = (businessId: string) =>
  `business/${businessId}/profile`

export const accountProfileImageReference = (
  businessId: string,
  entityType: ENTITY_TYPE,
  accountId: string
) =>
  `business/${businessId}/account/${
    entityType === ENTITY_TYPE.CUSTOMER ? 'CUSTOMER' : 'SUPPLIER'
  }/${accountId}/profile`

const extensionOf = (file: File) => {
  const fromName = file.name.includes('.') ? file.name.split('.').pop() : ''
  if (fromName) {
    return fromName.toLowerCase()
  }
  const fromType = file.type.split('/')[1]
  return fromType ? fromType.toLowerCase() : 'jpg'
}

// Uploads one photo to the merchant's Drive and returns the public view URL the apps store
// (`https://drive.google.com/uc?export=view&id=…`), or null when the upload failed.
export const uploadProfileImageToDrive = async (
  file: File,
  reference: string
): Promise<string | null> => {
  try {
    // KMP SyncFileWithGoogleDrive names the file `{name}_{fileId}_{ts}.{ext}`
    const renamed = new File([file], `profile_${uuidv4()}_${Date.now()}.${extensionOf(file)}`, {
      type: file.type,
      lastModified: file.lastModified
    })
    const result = await uploadFileToGoogleDrive(renamed, reference)
    return result?.url || null
  } catch (error) {
    console.error('Profile photo upload to Google Drive failed', error)
    return null
  }
}
